import React, { FC } from 'react';
import { create } from 'zustand';

const DEFAULT_QUIZ_ID = 'default';

export interface QuizStore {
  quizFeedback: Record<string, string>;
  getQuizFeedback: (quizId?: string) => string;
  setQuizFeedback: (feedback?: string, quizId?: string) => void;
  quizId: string;
  setQuizId: (id: string) => void;
}

export const useQuizStore = create<QuizStore>((set, get) => ({
  quizFeedback: {},
  getQuizFeedback: (quizId?: string) => {
    const rawId = quizId || get().quizId || DEFAULT_QUIZ_ID;
    // Ensure id is a string before calling split
    const id = typeof rawId === 'string' ? rawId : String(rawId);

    // Only split if id contains a dot
    const tempId = id.includes('.') ? id.split('.').slice(0, -1).join('.') : '';

    return (
      (tempId ? get().quizFeedback[tempId] : null) ||
      get().quizFeedback[id] ||
      ''
    );
  },
  setQuizFeedback: (feedback, quizId) => {
    const rawId = quizId || get().quizId || DEFAULT_QUIZ_ID;
    // Ensure id is a string
    const id = typeof rawId === 'string' ? rawId : String(rawId);

    set(state => ({
      quizFeedback: {
        ...state.quizFeedback,
        [id]: feedback || ''
      }
    }));
  },
  quizId: DEFAULT_QUIZ_ID,
  setQuizId: id => set({ quizId: id ? String(id) : DEFAULT_QUIZ_ID })
}));

export const QuizProvider: FC<{ quizId: string }> = ({ children, quizId }) => (
  <>{children}</>
);
